/**
 * Since LM-30 the backend puts a Transloco key into `CardType.description`
 * (`cards.usd.atm.description`), not human text. Card types the backend has not
 * migrated yet still carry plain English prose, so both shapes must render.
 *
 * The namespace is pinned to `cards.` on purpose: `description` is admin-supplied
 * data and `t()` can address the whole translation bundle.
 *
 * Keys are lowercase alphanumeric segments only — agreed with the backend so the
 * shape alone tells a key apart from a sentence.
 */
const DESCRIPTION_KEY = /^cards(\.[a-z0-9]+)+$/;

/** The translation key carried by `description`, or null when it is not a key. */
export function cardTypeDescriptionKey(description: string | null): string | null {
  const value = description?.trim() ?? '';
  return DESCRIPTION_KEY.test(value) ? value : null;
}

/** Pre-LM-30 plain text carried by `description`, or null when it is a key or empty. */
export function cardTypeDescriptionText(description: string | null): string | null {
  const value = description?.trim() ?? '';
  return value === '' || DESCRIPTION_KEY.test(value) ? null : value;
}
